import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import { ArrowBackIos as BackButtonIcon } from '@material-ui/icons'
import AppBar from '@material-ui/core/AppBar'
import { useSelector } from 'react-redux'
import { selectors as loadMenuDataSelectors } from '../selectors/loadMenuDataSelectors'
import { getBackgroundGradient } from '../utils/colorUtils'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  toolbar: theme.mixins.toolbar,
}))

const DigitalMenuAppBar = (props) => {
  const classes = useStyles()

  const colors = useSelector(loadMenuDataSelectors.getColors)
  const backgroundColor = getBackgroundGradient(colors.primary)

  return <>
    <AppBar position="fixed" style={{ background: backgroundColor }}>
      <Toolbar className={classes.toolbar}>
        <Grid container alignItems="center">
          <Grid item xs={1}>
            {props.handleBackButtonClick &&
            <IconButton
              edge="start"
              color="inherit"
              aria-label="Voltar"
              onClick={props.handleBackButtonClick}
            >
              <BackButtonIcon/>
            </IconButton>
            }
          </Grid>
          <Grid item xs={10}>
            {props.children ?
              props.children :
              <Box fontSize={24} className={classes.title}>
                Cardápio
              </Box>
            }
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
    {/*
      DEIXAR PARA DAR OFFSET PARA BAIXO
      https://github.com/mui-org/material-ui/issues/10076
    */}
    <Toolbar/>
  </>
}

DigitalMenuAppBar.propTypes = {
  children: PropTypes.any,
  handleBackButtonClick: PropTypes.func,
}

export default DigitalMenuAppBar
